import { render, staticRenderFns } from "./ConfirmNewQuote.vue?vue&type=template&id=1f10d352"
import script from "./ConfirmNewQuote.vue?vue&type=script&lang=ts"
export * from "./ConfirmNewQuote.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports